import { ListItem, Text, UnorderedList } from '@chakra-ui/react'

import ShwLink from '@/components/ShwLink'

export function Links({ links }: { links: string[] | null | undefined }): JSX.Element {
  if (links == null || links.length === 0) {
    return <Text>N/A</Text>
  }

  if (links.length === 1) {
    return <ShwLink href={links[0]}>{links[0]}</ShwLink>
  }
  return (
    <UnorderedList p={0}>
      {links.map(link => (
        <ListItem key={link}>
          <ShwLink href={link}>{link}</ShwLink>
        </ListItem>
      ))}
    </UnorderedList>
  )
}
